package com.hyperether.goodjob.util

object Logger {

    fun v(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.VERBOSE, tag, message, error, type)
    }

    fun d(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.DEBUG, tag, message, error, type)
    }

    fun i(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.INFO, tag, message, error, type)
    }

    fun w(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.WARN, tag, message, error, type)
    }

    fun e(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.ERROR, tag, message, error, type)
    }

    fun wtf(
        tag: String,
        message: String,
        error: Throwable? = null,
        type: LogType = LogType.INTERNAL
    ) {
        log(Priority.ASSERT, tag, message, error, type)
    }

}

enum class Priority {
    VERBOSE,
    DEBUG,
    INFO,
    WARN,
    ERROR,
    ASSERT
}

enum class LogType {
    INTERNAL
}

expect fun log(
    priority: Priority,
    tag: String,
    message: String,
    error: Throwable?,
    type: LogType
)